import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68b47a40&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=68b47a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b47a40",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PzTabs: require('/drone/src/components/pz-tabs/index.vue').default,CouponItem: require('/drone/src/components/CouponItem/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default})
